var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:({background:_vm.bgColor, color:_vm.color}),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }